__webpack_require__.p = "https://freshmenfish.github.io/econetv2/";